import React, { useState, createContext, useContext } from "react";
import Header from "./Header";
import Leftmenu from "./Leftmenu";

export const SidebarContext = createContext();

const LayoutHOC = (WrappedComponent) => {
  return function LayoutWrapper(props) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
      <SidebarContext.Provider value={{ sidebarCollapsed, setSidebarCollapsed }}>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <Leftmenu collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
          <div 
            className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-64'}`}
          >
            <WrappedComponent {...props} />
          </div>
        </div>
      </SidebarContext.Provider>
    );
  };
};

export default LayoutHOC;
